import React, { useMemo } from 'react';
import { ProteinView } from './protein/ProteinView';
import { LinePageHeader } from './components/SitePageHeader/SitePageHeader';
import { SiteViewContainer } from './SiteView.elements';

export const SiteView = (): JSX.Element => {
  return (
    <SiteViewContainer className="site-view-container">
      <LinePageHeader />
      <PageRoutes />
    </SiteViewContainer>
  );
};

const PageRoutes = () => {
  let businessUnit = 'protein';
  const CachedRoute = useMemo(() => {
    if (businessUnit === 'pemea') businessUnit = 'protein';

    switch (businessUnit) {
      case 'protein':
        return <ProteinView />;
      default:
        return <div>MachineView 404: invalid business unit in MachineView PageRoutes</div>;
    }
  }, [businessUnit]);

  return CachedRoute;
};
